
const devices_status = {

    1: 'ACTIVO',
    2: 'ELIMINADO',
    3: 'ORDEN EN PROCESO',
    11: 'EQUIPO ABANDONADO'
};

const devices_status_colors = {
    1: 'text-bg-primary',    // ACTIVO
    2: 'text-bg-danger',     // ELIMINADO 
    3: 'text-bg-warning',    // CON ORDEN ACTIVA
    11: 'text-bg-danger',     // ELIMINADO 

};

const memberships_status = {
    0: 'ELIMINADA',
    1: 'ACTIVO',
    2: 'VENCIDA'
};

const memberships_status_colors = {
    0: 'text-bg-danger',     // ELIMINADO 
    1: 'text-bg-primary',    // ACTIVO
    2: 'text-bg-warning',    // ACTIVO
};

const billings_status = {
    0: 'ELIMINADA',
    1: 'ACTIVO',
    2: 'ELIMINADA'
};

const billings_status_colors = {
    0: 'text-bg-danger',     // ELIMINADO 
    1: 'text-bg-primary',    // ACTIVO
    2: 'text-bg-danger',    // ACTIVO
};

const orders_status = {
    0: 'SIN ASIGNAR',
    1: 'ASIGNADA',
    2: 'SIN DIAGNOSTICO',
    3: 'CON DIAGNOSTICO',
    4: 'EN ESPERA DE COMPONENTE',
    5: 'COMPLETA / TERMINADA',
    6: 'NO APROBADA',
    7: 'APROBADA',
    8: 'CERRADA / ENTREGADA',
    9: 'CANCELADA',
    10: 'EQUIPO RETIRADO',
    11: 'EQUIPO ABANDONADO'
};

const orders_status_colors = {
    0: 'text-bg-danger',
    1: 'text-bg-primary',
    2: 'text-bg-warning',
    3: 'text-bg-secondary',
    4: 'text-bg-dark',
    5: 'text-bg-primary',
    6: 'text-bg-success',
    7: 'text-bg-success',
    8: 'text-bg-success',
    9: 'text-bg-danger',
    10: 'text-bg-warning',
    11: 'text-bg-dark',
};

const status_slices = {
    WAITING: 'waiting',
    PROCESSING: 'processing_request',
    LOADED: 'loaded',
    NOT_LOADED: 'not_loaded',
    ERROR: 'error',
    SUCCESS: 'success'
};


export {billings_status,billings_status_colors, status_slices, orders_status, orders_status_colors, devices_status, devices_status_colors, memberships_status, memberships_status_colors };